const wrap_side_menu = document.querySelector(".wrap_side_menu");

const MOBILE_BREAKPOINT = 1024;

export const getIsMobile = () => window.innerWidth < MOBILE_BREAKPOINT;

window.addEventListener("resize", () => {
    if (!wrap_side_menu) return;

    if (typeof servObj === "undefined") window.servObj = {};

    servObj.isMobile = getIsMobile();

    const isClosed = wrap_side_menu.classList.contains("close");
    if (!isClosed && servObj.isMobile) {
        document.querySelector(".cross_closer__menu")?.click();
    }
    if (isClosed && !servObj.isMobile) {
        document.querySelector(".cross_closer__menu")?.click();
    }
});
